import { PageStyle, CandidateStyle, ButtonStyle, Button, ClientDashboard, Checkbox, Form, Formik, FormikControl, Image, useEffect, useRouter, useState, clearSWRCache, SelectJobModalAction, ErrorPages, useSWR, CONSTANTS, Loading, useTranslation, InputError, useRef, components, Tooltip } from '@/imports-files/components/model/single-candidate-modal';
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from "react-accessible-accordion";
import { FormModalStyle } from "@/imports-files/components/common-modal/common-modal";
import Modal from "@/components/common-modal/modal";

export function SingleCandidateModal(props)
{
  const {t} = useTranslation()
  const { data, buttonPopup, setButtonPopup, viewScorecard, setShowViewScorecards } = props
  useEffect(() => {
    setTimeout(() => {
      var subcompetencies = Array.from(document.getElementsByClassName('collapsible'))
      if(subcompetencies && subcompetencies.length > 0){
        subcompetencies?.forEach((element, index) =>
        {
          element.classList.toggle("active");
          let content = element.nextElementSibling;
          if (content.style.maxHeight && content.style.maxHeight != '0px'){
            content.style.maxHeight = "0px";
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        })
      }
    }, 100)
  }, [viewScorecard, buttonPopup]);


  function collapsibleButtonClick(event){
    const currentElement = event.currentTarget
    currentElement.classList.toggle("active");
    let content = currentElement.nextElementSibling;
    if (content.style.maxHeight && content.style.maxHeight != '0px'){
      content.style.maxHeight = "0px";
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }

  function getScoreColor(score, isLight){
    let scoreValue = parseFloat(score)
    if((scoreValue == NaN) || (scoreValue == 0))
      return isLight ? 'LightNaBg' : 'NaBg'
    else if(scoreValue <= 2)
      return isLight ? 'LightRedBg' : 'RedBg'
    else if(scoreValue > 2 && scoreValue < 4)
      return isLight ? 'LightYellowBg' : 'YellowBg'
    else if(scoreValue >= 4)
      return isLight ? 'LightGreenBg' : 'GreenBg'
    else
      return isLight ? 'LightNaBg' : 'NaBg'
  }

  return buttonPopup || viewScorecard  ? (
    <>
    <Modal
    type="form"
    heading = {t('modal:form:scorecard:heading')}
    NoOuterPadding = {true}
    ScoreCardModal = {true}
    largeWidth = {true}
    closeModal={(event) => {
     setButtonPopup ? setButtonPopup(false) : setShowViewScorecards(false)
    }}
    content={
      <>
        <div className = {`${CandidateStyle.Modal__Body}`}>
            <div className = {`${CandidateStyle.Modal__Body__HeadingPlusScore}`}>
              <h1 className = {`${CandidateStyle.Modal__Body__MainHeading}`}>{data?.name}</h1>
              <div className = {`${CandidateStyle.Modal__Body__OverallScore}`}>
                <h4>{t('modal:form:scorecard:overall_score')}</h4>
                <div className = {`${CandidateStyle.Modal__Body__OverallScoreValue} ${getScoreColor(data?.scorecard_overall_score, false)}`}>
                  <span className = {`Average__Score`}>{data?.scorecard_overall_score}</span>
                </div>
              </div>
            </div>
                <div className={`Modal__Accordian`}>
                    <Accordion preExpanded={["overall_feedback"]} allowZeroExpanded className = {`accordion`}>
                      <AccordionItem uuid={`overall_feedback`}>
                        <AccordionItemHeading>
                            <AccordionItemButton className = {`accordion__button ${getScoreColor(data?.scorecard_overall_score, false)}`}>
                              <p className={`NoRightBorder`}>{t('modal:form:scorecard:overall_feedback')}</p>
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel className = {`accordion__panel`}>
                          {data?.overall_feedback.map((feedback, index) => {
                            return <div className = {`Accordian__Body`}>
                                <div className = { `Accordian__Body__Candidate__Details`}>
                                  <div className = {`Accordian__Body__CandidateImg`}>
                                    {feedback.reviewer?.photo_url ? <img src ={feedback.reviewer.photo_url} /> : feedback.reviewer?.name_initials  && <div className={CandidateStyle.Tagrow__Prefix}>{feedback.reviewer?.name_initials}</div> }
                                  </div>
                                  <div className = {`Accordian__Body__CandidateDescription`}>
                                    <div className = {`Accordian__Body__CandidateName`}>
                                      <p>{feedback.reviewer.name}</p>
                                      <p className = {`Accordian__Body__Flex`}>
                                        {/*<span className = {`Accordian__Body__Reviewer`}>{feedback.role}</span>*/}
                                       <span className = {`Accordian__Body__Date`}>{feedback.updated_at}</span></p>
                                    </div>
                                    <div className = {`Accordian__Body__CandidateFeedback`}>
                                      {feedback.feedback ? <p className = {`BlueText`}>{feedback.feedback}</p> : <p className = {`GreyText`}>{t('modal:form:scorecard:no_notes')} </p>}
                                    </div>
                                </div>
                              </div>
                              <div className = {`Accordian__Body__Candidate__Score ${getScoreColor(feedback.overall_score, true)}`}>
                                <p>{feedback.overall_score || 'N/A' }</p>
                              </div>
                            </div>
                          })
                          }
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                   { !data.only_feedback && data?.scorecard.competencies.length > 0 &&  <div className = {`Accordian__Title`}>
                      <p>{t('modal:form:scorecard:competencies')}</p>
                    </div> }


                      {!data.only_feedback && data?.scorecard.competencies.map((competency, index) => {
                        return <Accordion preExpanded={[`competency_${competency.id}`]} allowZeroExpanded className = {`accordion WhiteBg`}>
                        <AccordionItem uuid={`competency_${competency.id}`}>
                        <AccordionItemHeading>
                            <AccordionItemButton className = {`accordion__button ${getScoreColor(competency.competency_score, false)}`}>
                              <p className={`${competency.reviewers.length == 1 ? 'noborder' : ''}`}>{competency.competency_name}</p>
                              { competency.reviewers.length > 1 && <span className = {`Average__Score`}>{competency.competency_score || 'N/A'}</span>}
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        {(competency.reviewers.length > 0 || competency.sub_competencies.length > 0) && <AccordionItemPanel>
                          {competency.reviewers.map((reviewer, review_ndex) => {
                            return <div className = {`Accordian__Body`}>
                              <div className = { `Accordian__Body__Candidate__Details`}>
                                {competency.reviewers.length > 1 && <div className = {`Accordian__Body__CandidateImg`}>
                                  {reviewer.reviewer_detail?.photo_url ?<img src ={reviewer.reviewer_detail?.photo_url} />: reviewer.reviewer_detail?.name_initials  && <div className={CandidateStyle.Tagrow__Prefix}>{reviewer.reviewer_detail?.name_initials}</div> }
                                </div>}
                                <div className = {`Accordian__Body__CandidateDescription`}>
                                  {competency.reviewers.length > 1 && <div className = {`Accordian__Body__CandidateName`}>
                                    <p>{reviewer.reviewer_detail.name}</p>
                                    <p className = {`Accordian__Body__Flex`}>
                                     <span className = {`Accordian__Body__Date`}>{reviewer.date}</span></p>
                                  </div>}
                                  {competency.reviewers.length > 1 ? <div className = {`Accordian__Body__CandidateFeedback`}>
                                    {reviewer.info ? <p className = {`BlueText`}>{reviewer.info}</p> : <p className = {`GreyText`}>{t('modal:form:scorecard:no_notes')} </p>}
                                  </div>
                                  :
                                  <div className = {`Accordian__Body__CandidateFeedback ${reviewer.info ? '' : 'h-100'}`}>
                                    {reviewer.info ? <p className = {`BlueText mw100 pr10`}>{reviewer.info}</p> : <p className = {`GreyText d-flex align-items-center h-100`}>{t('modal:form:scorecard:no_notes')}  </p>}
                                  </div>
                                  }
                              </div>
                            </div>
                            <div className = {`Accordian__Body__Candidate__Score ${getScoreColor(reviewer.score, true)}`}>
                              <p>{reviewer.score || 'N/A'}</p>
                            </div>
                          </div>
                          })
                          }

                          <div className = {`Accordian__SubCompetancy`}>
                            {competency.sub_competencies.map((subcompetency, subcompetency_index) => {
                              return <>
                                <button class="collapsible" onClick={(event) => {
                                  if(subcompetency.reviewers.length > 0)
                                    collapsibleButtonClick(event)
                                }}><span className = {`w100 mr15`}>{subcompetency.sub_competency_name}</span>{subcompetency.reviewers.length > 1 && <span className = {`SubCompetancy__Score ${getScoreColor(subcompetency.sub_competency_score, false)}`}>{subcompetency.sub_competency_score || 'N/A'}</span>}</button>
                                <div class="content">
                                  {subcompetency.reviewers.map((reviewer, review_index) => {
                                    return <div className = {`Accordian__Body ${subcompetency.reviewers.length > 1 ? '': 'pl0'}`}>
                                    <div className = { `Accordian__Body__Candidate__Details`}>
                                      {subcompetency.reviewers.length > 1 && <div className = {`Accordian__Body__CandidateImg`}>
                                         {reviewer.reviewer_detail.photo_url ?<img src ={reviewer.reviewer_detail.photo_url} />: reviewer.reviewer_detail.name_initials  && <div className={CandidateStyle.Tagrow__Prefix}>{reviewer.reviewer_detail.name_initials}</div> }
                                      </div>}
                                      <div className = {`Accordian__Body__CandidateDescription`}>
                                        {subcompetency.reviewers.length > 1 && <div className = {`Accordian__Body__CandidateName`}>
                                          <p>{reviewer.reviewer_detail.name}</p>
                                           <p className = {`Accordian__Body__Flex`}>
                                            <span className = {`Accordian__Body__Date`}>{reviewer.date}</span></p>
                                        </div>}
                                        {subcompetency.reviewers.length > 1 ?
                                        <div className = {`Accordian__Body__CandidateFeedback pr10`}>
                                          {reviewer.info ? <p className = {`BlueText`}>{reviewer.info}</p> : <p className = {`GreyText`}>{t('modal:form:scorecard:no_notes')}  </p>}
                                        </div>
                                        :
                                        <div className = {`Accordian__Body__CandidateFeedback ${reviewer.info ? '' : 'h-100'}`}>
                                          {reviewer.info ? <p className = {`BlueText mw100 pr10`}>{reviewer.info}</p> : <p className = {`GreyText d-flex align-items-center h-100`}>{t('modal:form:scorecard:no_notes')} </p>}
                                        </div>
                                        }
                                      </div>
                                    </div>
                                    <div className = {`Accordian__Body__Candidate__Score ${getScoreColor(reviewer.score, true)}`}>
                                      <p>{reviewer.score}</p>
                                    </div>
                                  </div>
                                  })
                                }
                                </div>
                              </>
                            })
                            }
                          </div>
                        </AccordionItemPanel>}
                      </AccordionItem>
                      </Accordion>
                      })}

                </div>
              </div>
              <div className = {`${CandidateStyle.Modal__Footer}`}>
              </div>
      </>
    }
    />
    </>
  ) : (
    ""
  );
}